import React, {Component} from 'react';
import {IntlProviderConnected} from './components/common/intl/IntlProviderConnected';
import {addLocaleData} from 'react-intl';

export class App extends Component {
    componentWillMount() {
        const {localeData} = this.props;
        if (localeData) {
            addLocaleData(localeData);
        }
    }

    render() {
        const {Template} = require('slp-template');
        return (
            <IntlProviderConnected>
                <Template />
            </IntlProviderConnected>
        );
    }
}
